import React from 'react'
import { Routes, Route,Navigate } from 'react-router-dom'

import Home from './pages/Home'
import RightSide from './pages/RightSide'
import LeftSide from './pages/LeftSide'
import Branding from './pages/Branding'
import CvPreview from './pages/CvPreview'


const MainRoutes = () => ( 
  
  <div>   
  <Routes>
    <Route path="/" element={<Home/>}>
          <Route path='/' element={<Navigate replace to="/left"/>} />
          <Route path='left' element={<LeftSide />} />
					<Route path='right' element={<RightSide />} />
					<Route path='branding' element={<Branding/>} />
					<Route path='preview' element={<CvPreview/>} />
    </Route>    
    </Routes> 
  </div>
    


)

export default MainRoutes